import React, { FC } from "react";
import st from "./index.module.scss";
import Image from "next/image";
import { Button } from "@pepdirect/ui/button";
import { useRouter } from "next/router";
import {
  generateHashedId,
  logEcommProductClickedEvent,
} from "@pepdirect/helpers/analyticsLogger";
import { Product } from "@pepdirect/shared/types";

type Props = {
  imageUrl: string;
  title: string;
  slug: string;
  index: number;
  item?: Product;
};
export const ProductSlide: FC<Props> = ({
  imageUrl,
  title,
  slug,
  index,
  item,
}) => {
  const router = useRouter();

  const onBuyNowClick = () => {
    const itemListName = "cans|focus landing|carousel|the focus offering";
    const itemListId = generateHashedId(itemListName);
    logEcommProductClickedEvent(
      "",
      {
        _id: item?._id || "",
        gtin: item?.gtin,
        itemTitle: title.toLowerCase(),
        itemSlug: slug,
        itemPrice: item?.itemPrice ? item.itemPrice / 100 : null,
        itemDesignerArtistBrandName: item?.itemDesignerArtistBrandName || null,
        itemDimensions: item?.itemDimensions || null,
      } as Product,
      index,
      itemListName,
      itemListId
    );
    router.push(`/products/${slug}`);
  };

  return (
    <div className={st.container}>
      <Image
        src={imageUrl}
        alt="product image"
        width="180"
        height="520"
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <h2 className={st.title}>{title}</h2>
      <h3 className={st.subtitle}>FOCUS</h3>
      <div className={st["buy-button"]}>
        <Button onClick={onBuyNowClick}>Shop Now</Button>
      </div>
    </div>
  );
};
